export default __webpack_public_path__ + "static/media/step_C_UA.6c23ef96.png";